// extracted by mini-css-extract-plugin
module.exports = {"noImgBorder":"Avatar_noImgBorder__10-Cb","imgBorder":"Avatar_imgBorder__391LR"};